import {
  tokenSpacing4,
  tokenTextColorBrandPrimary
} from '@usb-shield/design-tokens/dist/responsive-web/consumer/consumer.module'
import PropTypes from 'prop-types'
import { cloneElement } from 'react'

const USBMobileHeader = ({
  title = '',
  rightIcon = null,
  leftIcon = null,
  // background = null,
  additionalClasses,
  handleRightIconClick = () => {
    // This is intentional
  },
  handleLeftIconClick = () => {
    // This is intentional
  }
}) => {
  const bpmobileheader = {
    display: 'flex',
    width: '100%',
    textAlign: 'center',
    padding: tokenSpacing4,
    color: tokenTextColorBrandPrimary,
    background: '#ffffff',
    '&.interaction': {
      background: '#ffffff',
      color: tokenTextColorBrandPrimary
    }
  }
  const bpmobileheadertitle = {
    display: 'flex',
    justifyContent: 'center',
    flex: 0.8
  }

  const bpmobileheadericon = {
    flex: 0.1,
    background: 'transparent',
    border: 'none',
    padding: 'unset',
    margin: 'unset'
  }
  const bpmobileheadernoicon = {
    flex: '0.1 1'
  }

  return (
    <div className={{ ...additionalClasses }} style={bpmobileheader}>
      {leftIcon ? (
        <button
          type="button"
          tabIndex="0"
          aria-label="back"
          style={bpmobileheadericon}
          onClick={handleLeftIconClick}
        >
          {cloneElement(leftIcon, { colorVariant: 'brand-primary' })}
        </button>
      ) : (
        <div style={bpmobileheadernoicon} />
      )}

      <h1
        id="mobile-header-title"
        className="usb-tg-subheader-large usb-c-usb-blue-primary"
        style={bpmobileheadertitle}
      >
        {title}
      </h1>
      <button
        type="button"
        tabIndex="0"
        aria-label="close"
        style={bpmobileheadericon}
        onClick={handleRightIconClick}
      >
        {cloneElement(rightIcon, { colorVariant: 'brand-primary' })}
      </button>
    </div>
  )
}

USBMobileHeader.propTypes = {
  title: PropTypes.string.isRequired,
  // background: PropTypes.string,
  handleLeftIconClick: PropTypes.func,
  handleRightIconClick: PropTypes.func,
  rightIcon: PropTypes.objectOf(PropTypes.any).isRequired,
  leftIcon: PropTypes.objectOf(PropTypes.any),
  additionalClasses: PropTypes.objectOf(PropTypes.any)
}

USBMobileHeader.defaultProps = {
  // background: '#ffffff',
  handleLeftIconClick: () => {
    // This is intentional
  },
  handleRightIconClick: () => {
    // This is intentional
  },
  leftIcon: null,
  additionalClasses: {}
}

export default USBMobileHeader
